import { Card, Typography } from '@mui/material';
import { PropTypes } from 'prop-types';

export default function CampaignCards({ details, title }) {
  return (
    <Card sx={{ p: 2, width: '100%', borderRadius: 1 }}>
      <Typography fontSize="0.8em" color="gray">
        {title}
      </Typography>
      <Typography variant="h5" mt={1}>{details}</Typography>
    </Card>
  );
}

CampaignCards.propTypes = {
  details: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
